import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  OTP as otpAction,
  OTPAction,
  OTPClear as otpClearAction,
} from '@triare/auth-redux/dist/saga/auth/OTP';
import {
  Alert,
} from 'antd';
import { AnyObject } from '@triare/auth-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../../../../../store';
import { moduleName, useAuth } from '../../../../../store/auth';
import Loading from '../../../../Common/Loading';
import Wrapper from '../../Wrapper';
import { getMessageInError } from '../../../../../hooks/fetch';
import ResendButton from '../../../../../pages/Auth/ConfirmOTP/ResendButton';

interface OTPVerificationProps {
  email?: string;

  OTP: (payload: OTPAction) => void;
  OTPClear: () => void;
  loading: boolean;
  error: null | AnyObject;

  otpGenerateError: null | AnyObject;
}

function OTPLinkConfirm({
  OTP,
  OTPClear,
  loading,
  error,
  otpGenerateError,
}: OTPVerificationProps): React.ReactNode | null {
  const { secretKey } = useParams();
  const { authorized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (secretKey) {
      OTP({ secretCode: secretKey });
    }
  }, [secretKey]);

  useEffect(() => {
    if (authorized) {
      navigate('/', { replace: true });
    }
  }, [authorized]);

  return (
    <Wrapper>
      <div style={{ position: 'relative' }}>
        <Alert
          type={error || otpGenerateError ? 'error' : 'info'}
          banner
          message="Confirm OTP"
          /* eslint-disable-next-line no-nested-ternary */
          description={loading ? (
            <Loading />
          ) : (
            !error && !otpGenerateError ? (
              'OTP confirmation page'
            ) : getMessageInError(error || otpGenerateError) || 'Something went wrong'
          )}
        />

        <ResendButton />
      </div>
    </Wrapper>
  );
}

export default connect(
  (state: RootState) => ({
    error: state[moduleName].OTP.error,
    loading: state[moduleName].OTP.loading,
    otpGenerateError: state[moduleName].OTP.generate.error,
  }),
  {
    OTP: otpAction,
    OTPClear: otpClearAction,
  },
)(OTPLinkConfirm);
